import { render, staticRenderFns } from "./EvaluationRP.vue?vue&type=template&id=0b6e1b2a&scoped=true&"
import script from "./EvaluationRP.vue?vue&type=script&lang=js&"
export * from "./EvaluationRP.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationRP.vue?vue&type=style&index=0&id=0b6e1b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e1b2a",
  null
  
)

export default component.exports